import { createContext } from 'react';
var UserContext = createContext({});
export default UserContext;
